import type { CityConfig } from "@/pages/city-template/types";

export const prinevilleConfig: CityConfig = {
  city: "Prineville",
  state: "Oregon",
  stateAbbr: "OR",
  slug: "prineville",
  route: "/cities/prineville",
  title: "Emergency Passport Prineville OR | Expedited Passport Crook County Oregon",
  metaDescription: "Emergency passport and expedited passport services in Prineville, OR — as fast as 24 hours. Fast Passport Center serves Prineville, Crook County, Redmond, Bend, and Central Oregon. Registered State Dept. courier. A+ BBB rated. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Prineville, Oregon",
  heroSubtitle: "Ranch equipment trade show in Canada booked? Family hunting trip to British Columbia and your passport expired? Outdoor adventure to New Zealand and you realize you need a passport fast from rural Oregon? Fast Passport Center helps Prineville and Crook County residents get expedited passports as fast as 24 hours — entirely remotely. No drive to Seattle required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Prineville%20Oregon%20high%20desert%20landscape%20with%20Ochoco%20Mountains%20in%20background%20and%20Crooked%20River%20winding%20through%20sagebrush%20and%20juniper%20ranchlands%2C%20classic%20small%20town%20rural%20Oregon%20with%20historic%20downtown%20Prineville%2C%20Crook%20County%20Courthouse%2C%20vast%20Central%20Oregon%20high%20desert%20scenery%20at%20golden%20hour%20with%20dramatic%20clouds%2C%20photorealistic%20cinematic%20quality%2C%20no%20text%20no%20people&width=1800&height=700&seq=prineville-or-hero-01&orientation=landscape",
  heroImageAlt: "Prineville Oregon high desert landscape with Ochoco Mountains and Crooked River ranchlands",
  geoPosition: "44.2998;-120.8345",
  geoPlacename: "Prineville, Oregon",
  lastModified: "2026-06-04",
  regionalAgency: {
    name: "Seattle Passport Agency",
    address: "300 5th Ave, Suite 600, Seattle, WA 98104",
    distance: "About 340 miles northwest — approximately 6 hours by car via US-26 and I-5",
  },
  nearbyCitiesZips: [
    { name: "Prineville", zips: "97754" },
    { name: "Redmond", zips: "97756" },
    { name: "Bend", zips: "97701, 97702, 97703" },
    { name: "Powell Butte", zips: "97753" },
    { name: "Post", zips: "97752" },
    { name: "Paulina", zips: "97751" },
    { name: "Mitchell", zips: "97750" },
    { name: "Madras", zips: "97741" },
    { name: "Terrebonne", zips: "97760" },
    { name: "Culver", zips: "97734" },
    { name: "Sisters", zips: "97759" },
    { name: "La Pine", zips: "97739" },
  ],
  benefits: [
    { icon: "ri-computer-line", title: "Start 100% Online from Prineville", desc: "Complete your emergency or expedited passport order from anywhere in Crook County — no road trip to Seattle required." },
    { icon: "ri-truck-line", title: "Overnight Shipping from Redmond or Bend", desc: "Ship your documents from FedEx Office in Bend or The UPS Store in Redmond — both support overnight delivery for expedited submissions." },
    { icon: "ri-shield-check-line", title: "Expert Document Review", desc: "Every application reviewed before submission — essential for rural Crook County residents 340 miles from the nearest passport agency." },
    { icon: "ri-calendar-check-line", title: "Reserved Agency Submission Access", desc: "We bypass the public appointment backlog with reserved Seattle Passport Agency slots — far faster than calling for an emergency appointment." },
  ],
  testimonials: [
    {
      name: "Wayne P.",
      location: "Prineville, OR",
      rating: 5,
      text: "We run a ranch in Crook County and needed passports for a Canadian cattle industry meeting in Alberta. Fast Passport Center renewed mine in 5 business days from Prineville. They walked us through overnight shipping from Redmond UPS. Rural Oregon doesn't mean slow passport service anymore.",
      service: "Expedited Passport Renewal",
    },
    {
      name: "Rebecca T.",
      location: "Powell Butte, OR",
      rating: 5,
      text: "Family trip to Costa Rica booked months ago, and my passport was expired. Fast Passport Center did it in 6 business days from Powell Butte. Shipped from FedEx in Bend. The rural Oregon high desert isn't the passport desert it used to be.",
      service: "Expedited Passport Renewal",
    },
    {
      name: "Joe M.",
      location: "Post, OR",
      rating: 5,
      text: "Emergency passport needed for a family situation in Canada. Fast Passport Center got it done in 3 days from rural Post, Oregon. They guided me through the Crook County Clerk acceptance step and expedited from there. I drove to RDM and flew through Seattle. Incredible service for truly rural Oregon.",
      service: "Emergency Passport Processing",
    },
  ],
  facilities: [
    {
      id: "crook-county-clerk",
      name: "Crook County Clerk's Office",
      type: "County Clerk Passport Acceptance",
      address: "300 NE 3rd St",
      city: "Prineville",
      state: "OR",
      zip: "97754",
      phone: "(541) 447-6553",
      hours: "Mon–Fri 8am–5pm",
      distance: "Downtown Prineville — Crook County Courthouse, primary passport acceptance for all of Crook County",
      website: "https://co.crook.or.us/clerk",
      websiteLabel: "Crook County Clerk",
      notes: "Primary passport acceptance facility for Prineville and Crook County residents. Generally good appointment availability — much better than Deschutes County offices.",
      icon: "ri-government-line",
    },
    {
      id: "prineville-post",
      name: "Prineville Post Office",
      type: "USPS Passport Acceptance",
      address: "155 NE Court St",
      city: "Prineville",
      state: "OR",
      zip: "97754",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4:30pm",
      distance: "Downtown Prineville — adjacent to the Crook County Courthouse",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Small facility but convenient for Prineville residents. Appointment required. Limited hours compared to the County Clerk.",
      icon: "ri-mail-line",
    },
    {
      id: "redmond-post",
      name: "Redmond Post Office",
      type: "USPS Passport Acceptance",
      address: "618 NW Hemlock Ave",
      city: "Redmond",
      state: "OR",
      zip: "97756",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–5pm",
      distance: "Redmond — about 20 miles west via OR-126",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Larger facility 20 miles west in Redmond. Alternative for Prineville residents who need evening shipping options (Redmond UPS stays open later).",
      icon: "ri-mail-line",
    },
    {
      id: "deschutes-county-clerk",
      name: "Deschutes County Clerk — Bend Office",
      type: "County Clerk Passport Acceptance",
      address: "1300 NW Wall St, Suite 200",
      city: "Bend",
      state: "OR",
      zip: "97703",
      phone: "(541) 388-6546",
      hours: "Mon–Fri 8am–5pm",
      distance: "Bend — about 37 miles southwest via US-26 and US-97",
      website: "https://www.deschutes.org/clerk",
      websiteLabel: "Deschutes County Clerk",
      notes: "Deschutes County Clerk in Bend is an alternative for west Crook County residents. However, for Crook County residents, the Crook County Clerk in Prineville is both closer and more convenient.",
      icon: "ri-government-line",
    },
    {
      id: "madras-post",
      name: "Madras Post Office",
      type: "USPS Passport Acceptance",
      address: "71 SE D St",
      city: "Madras",
      state: "OR",
      zip: "97741",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4:30pm",
      distance: "Madras — about 40 miles north via US-26",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Alternative for north Crook County and Jefferson County residents. Smaller office but often good appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "bend-post-main",
      name: "Bend Post Office",
      type: "USPS Passport Acceptance",
      address: "2300 NE 4th St",
      city: "Bend",
      state: "OR",
      zip: "97701",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–5pm",
      distance: "Bend — about 37 miles southwest",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Bend main post office — largest acceptance facility in the region. Appointment required. High demand during tourist season.",
      icon: "ri-mail-line",
    },
  ],
  faqs: [
    {
      q: "Can I get an emergency passport from Prineville, Oregon?",
      a: "Yes. Fast Passport Center handles emergency passport processing for Prineville residents as fast as 24 hours. The Seattle Passport Agency is about 6 hours from Prineville — we serve you entirely remotely via overnight shipping from FedEx Office in Bend or The UPS Store in Redmond. Start online, we handle the rest.",
    },
    {
      q: "How fast can I get an expedited passport from Prineville, OR?",
      a: "Expedited passport processing from Prineville takes 2–9 business days through Fast Passport Center. Most adult renewals don't require an in-person acceptance visit — ship overnight from FedEx Office in Bend or The UPS Store in Redmond.",
    },
    {
      q: "Where is the passport acceptance office in Prineville?",
      a: "Prineville's primary acceptance locations are the Crook County Clerk's Office (300 NE 3rd St, Crook County Courthouse) and the Prineville Post Office (155 NE Court St), both in downtown Prineville. The County Clerk generally has better availability than the post office.",
    },
    {
      q: "Is Prineville far from passport agencies compared to other Oregon cities?",
      a: "Yes. Prineville is 340 miles from the Seattle Passport Agency — roughly 6 hours by car — making it one of the most remote Oregon cities from any regional passport processing center. Fast Passport Center's overnight shipping service eliminates the need for this drive entirely.",
    },
    {
      q: "What airport do Prineville residents use for international travel?",
      a: "Roberts Field (RDM) in Redmond, 20 miles west via OR-126, is the primary airport for Prineville and Crook County travelers. RDM offers connections through Seattle, Portland, Denver, San Francisco, and Salt Lake City to international routes worldwide.",
    },
    {
      q: "Are there passport photo locations in Prineville?",
      a: "Yes. Walgreens in Prineville (365 NE Court St) and The UPS Store in Redmond (20 miles west) both offer passport photo services. Fred Meyer in Redmond and FedEx Office in Bend are also reliable options.",
    },
    {
      q: "Can I renew my passport from Prineville without visiting an office?",
      a: "Yes. Most adult Prineville residents renewing their passport can do so entirely by mail — no in-person acceptance visit required for renewals. Ship overnight from FedEx Office Bend or The UPS Store Redmond.",
    },
    {
      q: "What special passport challenges do rural Crook County residents face?",
      a: "Rural Crook County residents face three main challenges: extreme distance from regional passport agencies (340 miles to Seattle), limited local acceptance facility hours (Crook County Clerk handles all of Crook County with a small office), and fewer overnight shipping options (you must drive to Redmond or Bend for FedEx/UPS with late pickup times). Fast Passport Center addresses all three through our remote processing and shipping guidance.",
    },
    {
      q: "Can I get a child passport from Prineville?",
      a: "Yes. Child passports require an in-person acceptance visit at the Crook County Clerk's Office or Prineville Post Office — both parents must typically be present or provide notarized consent. Fast Passport Center provides the child passport checklist and expedites after the acceptance step.",
    },
    {
      q: "How much does expedited passport processing cost from Prineville?",
      a: "Fast Passport Center pricing includes the U.S. government passport fees plus our courier service fee — typically 30–100% lower than FedEx Office or retail passport services. We provide an exact price quote before any commitment.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — Prineville", address: "365 NE Court St, Prineville, OR 97754", hours: "Daily 8 AM – 10 PM" },
    { name: "The UPS Store — Redmond", address: "1722 SW Veterans Way, Redmond, OR 97756", hours: "Mon–Fri 8:30 AM – 6 PM, Sat 10 AM – 3 PM" },
    { name: "FedEx Office — Bend", address: "63465 N Hwy 97, Bend, OR 97703", hours: "Mon–Fri 7 AM – 10 PM, Sat–Sun 9 AM – 6 PM" },
    { name: "Fred Meyer — Redmond", address: "500 NW 7th St, Redmond, OR 97756", hours: "Daily 7 AM – 11 PM" },
    { name: "Walgreens — Redmond", address: "1705 SW Odem Medo Rd, Redmond, OR 97756", hours: "Daily 8 AM – 10 PM" },
    { name: "Costco Photo Center — Bend", address: "2500 NE Hwy 20, Bend, OR 97701", hours: "Mon–Fri 10 AM – 8:30 PM, Sat–Sun 9:30 AM – 6 PM" },
    { name: "Safeway — Madras", address: "375 SW 5th St, Madras, OR 97741", hours: "Daily 5 AM – 11 PM" },
  ],
  dmvLocations: [
    {
      name: "Prineville Driver & Motor Vehicle Services",
      address: "365 NE Court St, Prineville, OR 97754",
      hours: "Mon–Fri 8:30 AM – 5:00 PM (closed noon–1pm)",
      note: "Prineville DMV — driver licenses, REAL ID, and state ID cards for Crook County residents.",
      featured: true,
    },
    {
      name: "Redmond Driver & Motor Vehicle Services",
      address: "215 SE 7th St, Redmond, OR 97756",
      hours: "Mon–Fri 8:30 AM – 5:00 PM",
      note: "Redmond DMV — alternative for Prineville residents who need a larger office or different hours.",
      featured: false,
    },
    {
      name: "Bend Driver & Motor Vehicle Services",
      address: "222 NE Emerson Ave, Bend, OR 97701",
      hours: "Mon–Fri 8:30 AM – 5:00 PM",
      note: "Bend DMV — largest DMV in the region, serves south Deschutes County.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "RDM",
      name: "Roberts Field — Redmond Municipal Airport",
      distance: "Primary Central Oregon airport — about 20 miles west via OR-126 (30 minutes)",
      address: "2522 SE Jesse Butler Cir, Redmond, OR 97756",
      note: "Roberts Field (RDM) is the closest airport for Prineville travelers — a 30-minute drive west. RDM offers daily connections to Seattle, Portland, Denver, San Francisco, Salt Lake City, Phoenix, and Los Angeles for international routing.",
      flightUrl: "https://www.flyrdm.com/",
      flightLabel: "RDM Airport Website",
      featured: true,
    },
    {
      code: "PDX",
      name: "Portland International Airport",
      distance: "About 165 miles northwest via US-26 (3 hours)",
      address: "7000 NE Airport Way, Portland, OR 97218",
      note: "Portland International offers direct international flights but requires a 3-hour drive from Prineville. RDM connections are the practical option for most Crook County travelers.",
      flightUrl: "https://www.flypdx.com/",
      flightLabel: "PDX Airport Website",
      featured: false,
    },
    {
      code: "SEA",
      name: "Seattle-Tacoma International Airport",
      distance: "About 340 miles northwest (6 hours)",
      address: "17801 International Blvd, Seattle, WA 98158",
      note: "SEA-TAC is not practical for direct travel from Prineville. RDM connections through SEA are the recommended routing for Crook County passengers.",
      flightUrl: "https://www.portseattle.org/sea-tac",
      flightLabel: "SEA-TAC Airport Website",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport — Prineville & Crook County",
      description: "Cattle industry meeting in Alberta next week? Family emergency in Canada? Ranch equipment trip to Europe imminent? Fast Passport Center handles emergency passport processing for Prineville and Crook County residents — as fast as 24 hours. Serve entirely remotely.",
      bullets: ["As fast as 24 hours processing", "Reserved Seattle agency submission", "Dedicated agent and live status tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Expedited Passport Renewal",
      description: "Passport expired while living in rural Crook County? Prineville residents renew fast through Fast Passport Center — ship from FedEx Office Bend or The UPS Store Redmond overnight, we handle the expedited submission.",
      bullets: ["Fastest renewal for rural Crook County residents", "Ship overnight from Redmond or Bend", "Professional document review included"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost Passport Replacement",
      description: "Lost your passport in Prineville or before a rural-to-international trip? We guide Crook County travelers through DS-64 and expedited replacement — no Seattle trip required.",
      bullets: ["DS-64 theft/loss reporting guidance", "Expedited replacement timelines available", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport — Prineville Families",
      description: "Crook County families heading to Canada, Mexico, or international vacations need child passports. We guide you through the Crook County Clerk acceptance step in downtown Prineville.",
      bullets: ["Both parents typically required to consent", "Crook County Clerk or Prineville Post Office guidance", "Expedited after in-person acceptance step"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-add-line",
      title: "First-Time Passport Applications",
      description: "First passport from Prineville? In-person acceptance at the Crook County Clerk or Prineville Post Office is required. We guide you through every step and expedite from there.",
      bullets: ["Step-by-step acceptance guidance for Crook County facilities", "Photo location guide for Prineville and Central Oregon", "Expedited processing after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-truck-line",
      title: "Registered State Dept. Courier Service",
      description: "Fast Passport Center is a registered U.S. Department of State courier — not a reseller. We submit through reserved agency channels at 30–100% lower prices than retail services.",
      bullets: ["State Dept. registered courier", "Best price guarantee", "Not affected by government shutdowns"],
      badge: "Registered Courier",
      link: "https://fastpassportcenter.com/checkout/",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change & Specialty Passport Services",
      description: "Name change passports, damaged passport replacement, second passports for ranch and agricultural business travelers, hunting guides, and outdoor adventurers in Crook County.",
      bullets: ["Name change after marriage", "Damaged passport replacement", "Second passport for agricultural business travelers"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Same-day emergency passport processing for Prineville, Oregon residents with urgent international travel needs." },
    { name: "Expedited Passport", description: "Expedited passport processing for Prineville and Crook County residents in 2–9 business days." },
    { name: "Passport Renewal", description: "Fast passport renewal for Prineville, Oregon — ship overnight from FedEx Office Bend or The UPS Store Redmond." },
    { name: "Lost Passport Replacement", description: "Emergency passport replacement for Prineville travelers with lost or stolen passports." },
    { name: "Child Passport", description: "Expedited child passport services for Prineville and Crook County families." },
    { name: "Passport Courier Service", description: "Registered U.S. Department of State courier serving Prineville, Oregon and rural Central Oregon." },
  ],
  mistakes: [
    { icon: "ri-time-line", title: "Waiting Too Long Because 'I'm in Rural Oregon'", description: "Prineville residents often delay passport applications because they feel isolated from passport resources. Fast Passport Center's overnight shipping eliminates the 340-mile Seattle drive — start 2–9 business days before travel." },
    { icon: "ri-camera-off-line", title: "Submitting Poor-Quality Passport Photos", description: "Limited photo options in Prineville can lead to substandard photos. Walgreens in Prineville or The UPS Store in Redmond (20 miles) are your best bets. Fast Passport Center reviews photo specifications before submission." },
    { icon: "ri-file-damage-line", title: "Incomplete Forms or Missing Signatures", description: "One missing signature returns your application — costing weeks when you're 340 miles from Seattle. Our pre-submission review catches all errors." },
    { icon: "ri-pen-nib-line", title: "Wrong Birth Certificate Format", description: "Short-form birth certificates are rejected. We specify exactly what document format is needed based on your state of birth." },
    { icon: "ri-map-pin-time-line", title: "Underestimating Crook County's Extreme Distance from Passport Agencies", description: "Prineville is 340 miles from the Seattle Passport Agency — a 6-hour drive. Last-minute 'I'll just drive to Seattle' plans add $200+ in gas, food, and lost time. Use Fast Passport Center's overnight shipping from the start." },
    { icon: "ri-truck-line", title: "Not Knowing Where to Ship Overnight in Rural Oregon", description: "Many rural Crook County residents don't realize they can ship overnight from Redmond (The UPS Store, 20 miles west) or Bend (FedEx Office, 37 miles southwest). Our checklist includes exact locations with late cutoff times for rural Oregon overnight shipping." },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose your processing speed based on your Prineville travel date. Complete your secure order from home in minutes." },
    { number: "02", icon: "ri-file-list-3-line", title: "Receive Your Personalized Checklist", description: "We send a personalized document checklist — exactly what to gather, with Crook County acceptance location guidance." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Documents Overnight", description: "Drop off at FedEx Office in Bend or The UPS Store in Redmond for overnight delivery. Both are reliable options for Crook County residents." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Agency Access", description: "We submit through reserved Seattle Passport Agency slots — bypassing the public appointment backlog that stretches for weeks." },
    { number: "05", icon: "ri-passport-line", title: "Passport Shipped to Your Door", description: "Your completed passport ships directly to your Prineville or Crook County address. Live status tracking included." },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Must drive to Seattle — 6 hours from Prineville",
        "Life-or-death emergencies only",
        "Very limited appointment availability",
        "Long wait times even with appointment",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Ship overnight from Redmond or Bend",
        "Document review included",
        "Dedicated agent on your case",
        "Daily status updates",
        "Best price guarantee",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than USPS self-service",
        "Document review included",
        "Dedicated agent",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "Standard mail — no courier access",
        "6–13 weeks; can be longer in summer",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent",
        "Not suitable if travel is under 10 weeks away",
      ],
      highlight: false,
      muted: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — weeks-long wait, Seattle only", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Drive to Seattle — 6 hours from Prineville", fpc: "Ship overnight from Redmond or Bend" },
    { feature: "Processing Speed", agency: "Strict eligibility requirements", fpc: "As fast as 24 hours — multiple tiers" },
    { feature: "Document Review", agency: "None — errors cause rejection", fpc: "Professional review included" },
    { feature: "Rural Oregon Accessibility", agency: "Not accessible from rural Crook County", fpc: "Fully remote service via overnight shipping" },
    { feature: "Government Shutdowns", agency: "May be impacted", fpc: "Not affected" },
    { feature: "Best Price Guarantee", agency: "Govt. fees + 12-hour Seattle round trip cost", fpc: "Best price guarantee — no travel required" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Acceptance Locations", href: "#acceptance-facilities" },
    { label: "vs. Regional Agency", href: "#comparison" },
    { label: "FAQ", href: "#faq" },
    { label: "Local Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Redmond", route: "/cities/redmond" },
    { name: "Emergency passport help in Bend", route: "/cities/bend" },
    { name: "Fast passport renewal in Portland", route: "/cities/portland" },
    { name: "Rush passport services for Oregon residents", route: "/states/oregon" },
    { name: "Expedited passports statewide in Oregon", route: "/states/oregon" },
  ],
  fpcOfficeNote: "After placing your order online, we send your personalized checklist and overnight shipping instructions. Ship from FedEx Office in Bend or The UPS Store in Redmond — both available weekday evenings. No visit to our processing facility required for most services.",
  fpcOfficeDistance: "Serving Prineville and all of rural Crook County remotely",
  serviceAreaIntro: "Whether you are in Prineville, Powell Butte, Post, Paulina, Mitchell, or anywhere in Crook County — Fast Passport Center makes emergency and expedited passport processing simple without a drive to Seattle.",
  nearbyCitiesIntro: "We serve all Crook County communities and surrounding areas including Prineville, Powell Butte, Post, Paulina, Mitchell, Redmond, Bend, Madras, and Culver.",
  howItWorksIntro: "Getting an emergency or expedited passport from Prineville is simpler than a 6-hour drive to Seattle. Most Crook County clients never visit an office.",
  mistakesIntro: "These are the most common mistakes that cause delays for Prineville and Crook County passport applicants. We review your documents before submission to prevent all of them.",
  testimonialsIntro: "Real reviews from Prineville, Powell Butte, and rural Crook County travelers who needed their passports fast.",
  faqIntro: "The most common questions Prineville and Crook County residents ask about emergency and expedited passport services.",
  statePageRoute: "/states/oregon",
  statePageName: "Oregon",
  travelTiming: {
    title: "Travel & Passport Timing for Prineville and Crook County Residents",
    intro: "Prineville is the Crook County seat — a classic rural Oregon high desert community at the foot of the Ochoco Mountains, surrounded by working cattle ranches, juniper forests, and the Crooked River. Its extreme remoteness from passport agencies and rural agricultural identity create unique international travel patterns for Crook County residents.",
    cards: [
      {
        icon: "ri-store-2-line",
        title: "Agricultural & Ranching Industry International Travel",
        subtitle: "Cattle and ranch operations generate Canada, Mexico, and Europe trips",
        description: "Crook County's working ranches and agricultural operations generate international travel — Canadian cattle industry meetings (Alberta, Saskatchewan), agricultural equipment trade shows in Europe (Germany, Italy), and livestock genetics conferences. These trips are often scheduled with 4–8 weeks notice. Prineville's extremely remote location (340 miles to Seattle, 6 hours by car) makes traditional in-person passport processing impractical — Fast Passport Center's overnight shipping service is the practical alternative.",
        tip: "Ranch and agricultural business travelers in Crook County should keep their passport valid with at least 12 months remaining. Canadian industry meetings can arise with 4 weeks notice — expedited processing from Prineville handles these timelines perfectly.",
      },
      {
        icon: "ri-map-pin-2-line",
        title: "British Columbia & Alberta Hunting and Fishing Trips",
        subtitle: "BC and Alberta are the #1 international destinations for Crook County outdoorsmen",
        description: "Crook County has a strong hunting and fishing culture, and British Columbia and Alberta are the top international destinations — for big game hunting (elk, moose, bear), fly fishing (BC steelhead rivers), and outdoor adventure. These trips are planned months in advance, but passport issues are often discovered when purchasing Canadian hunting licenses or booking outfitters — typically 4–8 weeks before departure.",
        tip: "Canadian hunting licenses and outfitter bookings require passport information. Check passport validity the day you book your BC or Alberta hunt. Expedited processing from Prineville takes 2–9 business days.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "RDM Airport Access — Prineville's Window to the World",
        subtitle: "Roberts Field (RDM) in Redmond — 30 minutes west — makes international travel possible",
        description: "Roberts Field (RDM) in Redmond is a 30-minute drive from Prineville, making international travel surprisingly accessible for a rural high desert community. RDM connections through Seattle, Portland, Denver, and San Francisco open up global destinations. Prineville residents use RDM for everything from winter Mexico escapes to European heritage trips.",
        tip: "RDM's proximity to Prineville (30 minutes) makes international travel feel local — but passport requirements don't change. Check passport expiration before booking any international trip, even a quick connection through RDM.",
      },
      {
        icon: "ri-sun-line",
        title: "Mexico & Costa Rica — High Desert Winter Escape",
        subtitle: "Crook County winters are long, cold, and perfect for tropical escapes",
        description: "Prineville winters feature freezing temperatures, snow, and the Ochoco Mountains creating a dramatic winter landscape — and a powerful motivation for tropical escapes. Mexico (Puerto Vallarta, Cabo, Riviera Maya) and Costa Rica (Guanacaste) are the top winter destinations. Trips are booked in October–November for January–March travel.",
        tip: "Check passport expiration dates in September before booking that Mexico winter escape. Many Crook County residents discover passport issues 2–4 weeks before departure — perfect for 2–9 business day expedited processing.",
      },
    ],
    callout: {
      icon: "ri-landscape-line",
      title: "Prineville, Oregon — Rural High Desert at the Foot of the Ochocos",
      description: "Prineville sits at the intersection of working ranchlands, Ochoco Mountain wilderness, and Central Oregon's high desert identity. The city's unique character — Crook County seat, agricultural heritage, hunting and fishing culture, and extreme remoteness from major cities — creates a distinctive set of international travel patterns. Fast Passport Center has served Prineville and Crook County residents with expedited passports for agricultural industry travel, Canadian hunting trips, winter escapes, and RDM-connected international journeys.",
    },
  },
  destinations: {
    title: "Where Prineville Travelers Go — And Why Passports Get Urgent",
    intro: "These are the destinations and travel patterns we see most from Prineville and Crook County clients. Agricultural industry travel, Canadian hunting and fishing trips, RDM airport connections, and winter escapes create unique passport urgency for rural high desert residents.",
    stats: [
      { stat: "340 mi", label: "to Seattle Passport Agency — 6 hours driving; Prineville is one of Oregon's most remote cities from a regional passport office" },
      { stat: "RDM", label: "Roberts Field in Redmond — 30 minutes west via OR-126; Prineville's primary international travel gateway" },
      { stat: "6 hrs", label: "to Seattle by car — the longest drive from any mid-sized Oregon city to a regional passport agency" },
      { stat: "2–9", label: "business days for Fast Passport Center expedited processing from Prineville" },
    ],
    destinations: [
      { name: "Canada — British Columbia & Alberta", context: "Top international destination: hunting (BC/Alberta elk, moose, bear), fishing (BC steelhead), and cattle industry meetings in Alberta", urgency: "Hunting licenses/outfitter bookings 8–12 weeks ahead; passport discovery at booking time", icon: "ri-map-pin-2-line" },
      { name: "Mexico — Puerto Vallarta, Cabo, Riviera Maya", context: "Winter escape from Prineville's freezing high desert — tropical beaches booked in October for January departure via RDM", urgency: "October–November booking; passport issues discovered 2–4 weeks before departure", icon: "ri-sun-cloudy-line" },
      { name: "Germany & Italy — Agricultural Equipment Trade", context: "Crook County ranchers attending European agricultural equipment expos (Hannover, Bologna) and livestock genetics conferences", urgency: "Trade shows scheduled 12–16 weeks ahead; passport renewal needed 8 weeks before departure", icon: "ri-store-2-line" },
      { name: "Costa Rica — Guanacaste Eco-Adventure", context: "Eco-adventure and surf trips popular with Crook County's outdoor-oriented community for winter escapes", urgency: "November–January booking for February–April travel; expeditions require passport 60 days ahead", icon: "ri-leaf-line" },
      { name: "Japan & South Korea — Agricultural Technology", context: "Japanese and Korean agricultural technology exchange visits — rice, livestock genetics, and precision farming equipment", urgency: "Agricultural exchange visits planned 12–16 weeks out; expedited processing serves these timelines well", icon: "ri-global-line" },
      { name: "New Zealand — Agricultural Trade & Adventure", context: "New Zealand sheep and cattle industry conferences plus outdoor adventure (Southern Alps) — mirroring Crook County's ranching and outdoor identity", urgency: "Agricultural conferences scheduled 6–12 months ahead; New Zealand visa requires valid passport 3 months beyond return", icon: "ri-compass-3-line" },
    ],
    crossLinksTitle: "Explore Nearby Oregon Service Areas",
    crossLinksDesc: "We serve travelers throughout Central Oregon and the high desert with the same expedited passport expertise.",
    crossLinks: [
      { name: "Redmond", route: "/cities/redmond" },
      { name: "Bend", route: "/cities/bend" },
      { name: "Portland", route: "/cities/portland" },
    ],
  },
};